import React, { useState } from "react";
import CryptoJS from "crypto-js";
import "./HmacCalculator.css";

function HmacCalculator() {
  const [dataToEncrypt, setDataToEncrypt] = useState("");
  const [keyToEncrypt, setKeyToEncrypt] = useState("");
  const [dataEncrypted, setDataEncrypted] = useState("");
  const [selectedAlgoritmo, setSelectedAlgoritmo] = useState("");

  const encryptProcess = () => {
    if (
      dataToEncrypt !== "" &&
      keyToEncrypt !== "" &&
      selectedAlgoritmo !== ""
    ) {
      let encrypted = "";
      switch (selectedAlgoritmo) {
        case "hmac128": {
          encrypted = CryptoJS.HmacSHA1(dataToEncrypt, keyToEncrypt).toString(
            CryptoJS.enc.Hex
          );
          break;
        }
        case "hmac256": {
          encrypted = CryptoJS.HmacSHA256(dataToEncrypt, keyToEncrypt).toString(
            CryptoJS.enc.Hex
          );
          break;
        }
        case "hmac512": {
          encrypted = CryptoJS.HmacSHA512(dataToEncrypt, keyToEncrypt).toString(
            CryptoJS.enc.Hex
          );
          break;
        }
        default:
          break;
      }
      setDataEncrypted(encrypted);
    } else {
      alert("Digite información, llave o seleccione algoritmo para encriptar");
    }
  };

  return (
    <div>
      <div className="card card-custom">
        <div className="card-header">
          <h2>Calculadora HMAC</h2>
        </div>
        <div className="card-body">
          <div class="form-group">
            <label for="initData">
              <strong>Informaci&oacute;n:</strong>
            </label>
            <input
              type="text"
              className="form-control"
              id="initData"
              placeholder="Ingrese Información"
              value={dataToEncrypt}
              onChange={(e) => setDataToEncrypt(e.target.value)}
            />
          </div>
          <hr />
          <div class="form-group">
            <label for="keyData">
              <strong>Llave:</strong>
            </label>
            <input
              type="text"
              className="form-control"
              id="keyData"
              placeholder="Ingrese llave"
              value={keyToEncrypt}
              onChange={(e) => setKeyToEncrypt(e.target.value)}
            />
          </div>
          <hr />
          <div class="form-group">
            <label for="keyAlgoritmo">
              <strong>Algoritmo:</strong>
            </label>
            <select
              className="form-control"
              id="keyAlgoritmo"
              value={selectedAlgoritmo}
              onChange={(e) => setSelectedAlgoritmo(e.target.value)}
            >
              <option value="">SELECCIONE</option>
              <option value="hmac128">Hmac 128 bits</option>
              <option value="hmac256">Hmac 256 bits</option>
              <option value="hmac512">Hmac 512 bits</option>
            </select>
          </div>
          <hr />
          <button
            type="submit"
            className="btn btn-primary"
            onClick={encryptProcess}
          >
            <strong>Generar HMAC</strong>
          </button>
          <hr />
          <div class="form-group">
            <label for="resultData">
              <strong>Resultado:</strong>
            </label>
            <textarea
              type="text"
              className="form-control"
              id="resultData"
              value={dataEncrypted}
              readOnly
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HmacCalculator;
